(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTopbarAnimations() {
      var topbars = document.querySelectorAll('.topbar[data-topbar-animation]');
      topbars.forEach(function (topbar) {
        var animation = topbar.getAttribute('data-topbar-animation');
        var loop = topbar.getAttribute('data-topbar-loop');
        var content = topbar.querySelector('.topbar__content');
        if (!content || animation === 'none') return;

        var contentWidth = content.scrollWidth;
        var containerWidth = topbar.offsetWidth;
        var totalDistance = contentWidth + containerWidth;
        var speed = 60;
        var duration = totalDistance / speed;

        content.style.setProperty('--topbar-duration', duration + 's');

        if (loop === 'false') {
          content.style.animationIterationCount = '1';
          content.style.animationFillMode = 'forwards';
        } else {
          content.style.animationIterationCount = 'infinite';
        }
      });
    }

    function initTopbarTimers() {
      var timers = document.querySelectorAll('[data-topbar-timer]');
      timers.forEach(function (timer) {
        var days = parseInt(timer.getAttribute('data-duration-days') || '0', 10);
        var hours = parseInt(timer.getAttribute('data-duration-hours') || '0', 10);
        var minutes = parseInt(timer.getAttribute('data-duration-minutes') || '0', 10);
        var seconds = parseInt(timer.getAttribute('data-duration-seconds') || '0', 10);
        var expiredText = timer.getAttribute('data-expired-text') || '';
        var sectionId = timer.getAttribute('data-section-id') || 'default';

        // Total duration in milliseconds
        var totalDurationMs =
          (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds) * 1000;

        if (totalDurationMs <= 0) return;

        // Use localStorage to persist the end time across page reloads
        var storageKey = 'topbar_timer_end_' + sectionId;
        var durationKey = 'topbar_timer_duration_' + sectionId;
        var storedEnd = localStorage.getItem(storageKey);
        var storedDuration = localStorage.getItem(durationKey);
        var endTime;

        // If no stored end time, or duration changed, reset the timer
        if (!storedEnd || parseInt(storedDuration, 10) !== totalDurationMs) {
          endTime = new Date().getTime() + totalDurationMs;
          localStorage.setItem(storageKey, endTime.toString());
          localStorage.setItem(durationKey, totalDurationMs.toString());
        } else {
          endTime = parseInt(storedEnd, 10);
          // If already expired, restart the timer
          if (endTime <= new Date().getTime()) {
            endTime = new Date().getTime() + totalDurationMs;
            localStorage.setItem(storageKey, endTime.toString());
          }
        }

        var daysEl = timer.querySelector('[data-timer-days]');
        var hoursEl = timer.querySelector('[data-timer-hours]');
        var minutesEl = timer.querySelector('[data-timer-minutes]');
        var secondsEl = timer.querySelector('[data-timer-seconds]');

        function pad(num) {
          return num < 10 ? '0' + num : '' + num;
        }

        function updateTimer() {
          var now = new Date().getTime();
          var distance = endTime - now;

          if (distance < 0) {
            if (expiredText) {
              timer.innerHTML = '<span class="topbar__timer-expired-msg">' + expiredText + '</span>';
            } else {
              timer.classList.add('expired');
            }
            clearInterval(intervalId);
            return;
          }

          var d = Math.floor(distance / (1000 * 60 * 60 * 24));
          var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var s = Math.floor((distance % (1000 * 60)) / 1000);

          if (daysEl) daysEl.textContent = pad(d);
          if (hoursEl) hoursEl.textContent = pad(h);
          if (minutesEl) minutesEl.textContent = pad(m);
          if (secondsEl) secondsEl.textContent = pad(s);
        }

        updateTimer();
        var intervalId = setInterval(updateTimer, 1000);
      });
    }

    function initAll() {
      initTopbarAnimations();
      initTopbarTimers();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('resize', initTopbarAnimations);
  })();

  } catch(e) { console.error(e); }
})();
})();
